<template>
  <div class="modal product-modal">
    <div class="overlay" @click="$parent.closeProductModal"></div>
    <div class="wrapper">
      <img src="../img/corners3/top-left-corner.svg" class="top-left" />
      <img src="../img/corners3/top-right-corner.svg" class="top-right" />
      <img src="../img/corners3/bottom-left-corner.svg" class="bottom-left" />
      <img src="../img/corners3/bottom-right-corner.svg" class="bottom-right" />
      <img
        class="close"
        src="../img/close.svg"
        @click="$parent.closeProductModal"
      />
      <div class="container">
        <div class="flex">
          <div class="preview">
            <img
              class="img"
              :src="$parent.imgDomain + $parent.chosenProoduct.img + '.png'"
            />
          </div>
          <div class="text">
            <div class="name-container">
              <div class="title dark">{{ $parent.chosenProoduct.name }}</div>
              <div class="desc dark status">
                Product available on all servers
              </div>
            </div>
            <div class="price-container">
              <div class="price">
                <span class="desc amount">{{
                  $parent.chosenProoduct.price
                }}</span>
                <img src="../img/coin.svg" class="coin" />
              </div>
              <div @click="buyProduct" class="button">ADD TO CART</div>
            </div>
          </div>
        </div>

        <transition name="fade">
          <div class="desc error" v-if="error">{{ error }}</div>
        </transition>
        <transition name="fade">
          <div class="desc dark error success" v-if="success">
            {{ success }}
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductModal",
  props: ["currency"],
  data: function () {
    return {
      error: "",
      success: "",
    };
  },
  methods: {
    buyProduct() {
      this.$http
        .post(process.env.VUE_APP_API + "cart/add", {
          id: this.$parent.chosenProoduct.id,
          count: 1,
        })
        .then((res) => {
          let self = this;
          if (res.data.status === "OK") {
            this.success = "Added";
            this.$parent.getCartContents();
            setTimeout(function () {
              this.success = "";
              self.$parent.closeProductModal();
            }, 1500);
          }
          if (res.data.status === "ERROR") {
            this.error = res.data.message;
            setTimeout(function () {
              self.error = "";
            }, 1500);
          }
        })
        .catch((res) => {
          let self = this;
          this.error = res.response.data.message;
          console.log(res);
          setTimeout(function () {
            self.error = "";
          }, 1500);
          if (res.response.status === 401) {
            this.$parent.openSignInModal();
          }
        });
    },
  },
};
</script>
